import React from "react";
import { Link } from "react-router-dom";
import InputField from '../Inputs/InputField'
import SigninValidator from '../../validators/Signin'
import { Field, reduxForm } from 'redux-form'
import { Trans } from "react-i18next";
import {
  Button,
  Card,
  CardBody,
  Form,
  FormGroup,
  Label,
  Input,
  CustomInput
} from "reactstrap";

const SignIn = ({handleSubmit,signInAction,submitting,current_user}) => (
  <div>
	  <div className="text-center mt-4">
	    <h2><Trans>login.welcome</Trans></h2>
	    <p className="lead"><Trans>login.sign_in_to_continue</Trans></p>
	  </div>

	  <Card>
	    <CardBody>
		    <div className="m-sm-4">
		      <div className="text-center">
			      <img
			        src="/logo.svg"
			        alt="logo"
			        className="img-fluid"
			        width="132"
			        height="132"
			      />
		      </div>
		      <Form  onSubmit={handleSubmit(signInAction)}>
			      <FormGroup>
			        <Label><Trans>login.email</Trans></Label>
			        <InputField name='email' placeholder="Enter your email" type='text' />
			      </FormGroup>
			      <FormGroup>
			        <Label><Trans>login.password</Trans></Label>
			        <InputField name='password' placeholder="Enter your password" type='password' />
			      </FormGroup>
            {current_user && current_user.auth && <div><i className="text-danger">{current_user.auth.message}</i></div>}
            <div><a href="/users/password/new">Hai dimenticato la password? Clicca qui per resettarla</a></div>
			      <div className="text-center mt-3">
			        <Button color="primary" type="submit" disabled={submitting}><Trans>login.sign_in</Trans></Button>			    
			      </div>
		      </Form>
		    </div>
	    </CardBody>
	  </Card>
  </div>
);

export default reduxForm({
  form: 'sign_in_form',
  enableReinitialize: true,
  destroyOnUnmount: false,
  validate: SigninValidator
})(SignIn);
